import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Controls from "../controls/Controls";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  dialogWrapper: {
    padding: theme.spacing(3),
    position: "absolute",
    width: "100%",
  },
  dialogTitle: {
    paddingRight: "0px",
  },
}));

export default function Popup({
  title,
  children,
  openPopup,
  setOpenPopup,
  onClose,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={openPopup}
      onClose={onClose}
      maxWidth="md"
      classes={{ paper: classes.dialogWrapper }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: "flex" }}>
          <Typography variant="h4" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Controls.ActionButton
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              setOpenPopup(false);
              onClose();
            }}
          >
            <CloseIcon />
          </Controls.ActionButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}
